module.exports = __webpack_public_path__ + "static/media/logo_original.609b88d9.png";